/* ---------------------------------------------------------------------------
(c) 2023-2024, HID Global Corporation, part of ASSA ABLOY.
All rights reserved.

This program is an un published copyrighted work which is proprietary
to HID Global Corporation. This computer program includes Confidential,
Proprietary Information and is a Trade Secret of HID Global Corporation.
Any use, disclosure, modification and/or reproduction is prohibited
unless authorized in writing by HID Global Corporation.

WARNING:  Unauthorized reproduction of this program as well as
unauthorized preparation of derivative works based upon the
program or distribution of copies by sale, rental, lease or
lending are violations of federal copyright laws and state trade
secret laws, punishable by civil and criminal penalties.
--------------------------------------------------------------------------- */
import { Routes } from '@angular/router';

import { authGuard } from './auth/auth.guard';

export const routes: Routes = [
  {
    path: ':id',
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () => import('./login/login.component').then((m) => m.LoginComponent)
      },
      {
        path: '',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./layout/portal-layout/portal-layout.component').then((m) => m.PortalLayoutComponent),
        children: [
          {
            path: 'home',
            canActivate: [authGuard],
            loadComponent: () => import('./home/home.component').then((m) => m.HomeComponent)
          },
          {
            path: 'hid-approve-setup',
            canActivate: [authGuard],
            loadComponent: () =>
              import('./hid-approve-setup/hid-approve-setup.component').then((m) => m.HidApproveSetupComponent)
          }
        ]
      }
    ]
  },
  {
    path: '**',
    loadComponent: () =>
      import('./shared/components/page-not-found/page-not-found.component').then((m) => m.PageNotFoundComponent)
  }
];
